import { render, staticRenderFns } from "./StudyForm.vue?vue&type=template&id=75c2de72&scoped=true"
import script from "./StudyForm.vue?vue&type=script&lang=js"
export * from "./StudyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c2de72",
  null
  
)

export default component.exports